export const HEADLINE = "Great Products";
export const TITLE = "Created together";
export const PARAGRAPH = "Join us on a journey to a perfect product.";
export const LETS_TALK = "Let's Talk";
